var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 45H8V3H30L40 13V45Z",
    fill: "#90CAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 14H29V4.5L38.5 14Z",
    fill: "#E1F5FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23L14 33H28L21 23Z",
    fill: "#1565C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 26.4L23 33H33L28 26.4Z",
    fill: "#1976D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 26C32.3284 26 33 25.3284 33 24.5C33 23.6716 32.3284 23 31.5 23C30.6716 23 30 23.6716 30 24.5C30 25.3284 30.6716 26 31.5 26Z",
    fill: "#1976D2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.9574f5790b424d000c8e772b6a919b30.svg";
export { ForwardRef as ReactComponent };